"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createNewsletterSubscription = require("./createNewsletterSubscription");
Object.keys(_createNewsletterSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createNewsletterSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createNewsletterSubscription[key];
    }
  });
});
var _useGetFooterContent = require("./useGetFooterContent");
Object.keys(_useGetFooterContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetFooterContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetFooterContent[key];
    }
  });
});